import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import service from '../services/faqService';
import { recordError } from '../utils/logService';

import {
  Messages,
  Notify,
  openNotification,
  util,
} from '@seims/shared';

// ---------------- Query Keys ----------------
const faqKeys = {
  all: ['frequently-aske-questions'],
};

/**
 * 
 *Retrun List of FAQ's
 */
export function useListFaq() {
  return useQuery({
    queryKey: faqKeys.all,
    queryFn: async () => {
      try {
        const res = await service.getFaq();
        const {data = [] } = res;
        return data
      } catch (error) {
        recordError(error);
        throw error;
      }
    },
    keepPreviousData: true,
    staleTime: 30_000,
  });
}
/**
 * 
 * Add FAQ
 */
export function useAddFaq() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: service.addFaq,
    onSuccess: () => {
      openNotification(
        'Create Faq',
        util.parseMessage(Messages.ADD_SUCCESS, 'Faq'),
        Notify.SUCCESS,
      );
      qc.invalidateQueries({ queryKey: faqKeys.all });
    },
    onError: (error) => {
      recordError(error);
      openNotification(
        'Create Faq',
        util.parseMessage(Messages.ADD_FAILURE, 'Faq'),
        Notify.ERROR,
      );
    },
  });
}
/**
 * 
 * Update FAQ
 */
export function useUpdateFaqDetails() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: service.updateFaq,
    onSuccess: () => {
      openNotification(
        'Update Faq',
        util.parseMessage(Messages.UPDATE_SUCCESS, 'Faq'),
        Notify.SUCCESS,
      );
      qc.invalidateQueries({ queryKey: faqKeys.all });
    },
    onError: (error) => {
      recordError(error);
      openNotification(
        'Update Faq',
        util.parseMessage(Messages.UPDATE_FAILURE, 'Faq'),
        Notify.ERROR,
      );
    },
  });
}